import * as React from 'react';

export const PaginationComponent = ({ pages, currentPage, selectPage }) => {
    return (<div className='ui container center aligned' style={{ marginTop: 20 }}>
        <div className='ui pagination menu'>
            {pages.map((page, index) => {
                if (page !== '...' && page !== currentPage) {
                    return <a key={index} className='item' href='javascript:void(0)' onClick={(e) => {
                            e.preventDefault();
                            selectPage(+page);
                        }}>{page}</a>
                }
                else if (page === '...' || page === currentPage) {
                    let css = 'item disabled';
                    if (currentPage === page) {
                        css = 'item active';
                    }

                    return <div key={index} className={css}>{page}</div>
                }
                else {
                    return <div></div>
                }
            })}
        </div>
    </div>);
};



// WEBPACK FOOTER //
// ./src/components/common/pagination/pagination.presentation.tsx